import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

const SecondaryCameraPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [isCustomElementReady, setIsCustomElementReady] = useState(false);
  const mobileCameraRef = useRef<any>(null);

  useEffect(() => {
    // Same pattern as ExamFlowPage — poll until custom element is registered
    const checkCustomElement = () => {
      if (customElements.get('rpt-mobile-camera')) {
        setIsCustomElementReady(true);
      } else {
        setTimeout(checkCustomElement, 100);
      }
    };
    checkCustomElement();
  }, []);

  useEffect(() => {
    if (!isCustomElementReady || !mobileCameraRef.current || !token) return;

    // Pass token as attribute once element is ready
    mobileCameraRef.current.setAttribute('token', token);

    // Listen for events from Angular component if needed
    mobileCameraRef.current.addEventListener('connectionStatusChange', (e: any) => {
      console.log('Secondary camera connection status:', e.detail);
    });
  }, [isCustomElementReady, token]);

  if (!isCustomElementReady) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <h2>📷 Loading Camera System...</h2>
        <p>Please wait while the camera component is being loaded...</p>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <rpt-mobile-camera
        ref={mobileCameraRef}
        token={token}
        style={{ width: '100%', height: '100vh' }}
      ></rpt-mobile-camera>
    </div>
  );
};

export default SecondaryCameraPage;